module.exports = __webpack_public_path__ + "img/azaka_yes.a585f008.png";